<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'user.details', params: { id: $route.params.id } }"
          >{{ userName }}</router-link
        >
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{
            name: 'user.details',
            hash: '#tools',
            params: { id: $route.params.id }
          }"
          >Tools</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <tool-form :tool="job" />
    </div>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { mdiChevronLeft, mdiCheck, mdiAlertCircleOutline } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ToolForm from '@/views/Home/Users/Tools/components/ToolForm'

export default {
  components: {
    AppBarNavIcon,
    ToolForm
  },

  watch: {
    $route() {
      this.getJob()
    }
  },

  computed: {
    ...mapState({
      job: state => state.job.jobDetails
    }),

    userName() {
      return this.job && this.job.owner ? this.job.owner.full_name : 'User'
    }
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
        check: mdiCheck,
        alert: mdiAlertCircleOutline
      },

      loading: false
    }
  },

  methods: {
    ...mapActions({
      getJobDetails: 'job/getJobDetails'
    }),

    ...mapMutations({
      clearJobDetails: 'job/clearJobDetails'
    }),

    async getJob() {
      this.loading = true
      await this.getJobDetails({
        user: this.$route.params.id,
        id: this.$route.params.toolId
      })
      this.loading = false
    }
  },

  created() {
    this.getJob()
  },

  destroyed() {
    this.clearJobDetails()
  }
}
</script>
